import styled from 'styled-components'
import { breakpoints } from '../../../../constants/breakpoints.constants'
import { BLUE } from '../../../../styles/colors.style'

export const StyledMuvibusInfo = styled.section`
	width: 100%;
	padding-bottom: 4rem;

	.title-info {
		font-weight: 600;
		text-align: center;
		margin: 4rem 0;
		color: var(--title-color);

		div:first-child {
			font-size: 4.6rem;
			padding-bottom: 2rem;
		}

		div:last-child {
			width: 500px;
			font-size: 3rem;
			margin-left: auto;
			margin-right: auto;
			padding-bottom: 1rem;

			@media (max-width: ${breakpoints.MOBILE}px) {
				width: 97vw;
			}
		}
	}

	.content {
		margin: auto;
		text-align: center;
		max-width: 100%;
		display: flex;
		flex-direction: row;
		color: var(--title-color);
		padding-bottom: 3rem;
		justify-content: center;

		div {
			margin: 0px 10px;
		}

		p {
			color: var(--title-color);
			max-width: 350px;
		}

		@media (max-width: ${breakpoints.MOBILE}px) {
			display: block;
			max-width: 100%;

			div {
				margin-top: 5rem;
			}

			p {
				max-width: initial;
			}
		}
	}
`
